import _ from 'lodash';
import { ITabOption } from './types';

export const getVisibleTabOptions = <T extends string>(
  options: ITabOption<T>[],
  conditions: Record<T, boolean>
): ITabOption<T>[] => _.filter(options, (x) => conditions[x.value]);
